/*
 * Carrier rates are stored in cents and typed in dollars. Unlike
 * `deliveryFeeSnapshot`, this pair is consistent — every read goes through
 * `centsToDollarsInput` and every write through `dollarsInputToCents`.
 */

/** Cents → the dollar string an input shows. Zero renders blank, not "0.00". */
export const centsToDollarsInput = (value: unknown): string => {
  const cents = Number(value ?? 0);

  if (!Number.isFinite(cents) || cents === 0) {
    return '';
  }

  return (cents / 100).toFixed(2);
};

/** The dollar string back to cents. Blank means zero. */
export const dollarsInputToCents = (value: unknown): number => {
  const normalized = String(value ?? '').trim();

  if (!normalized) {
    return 0;
  }

  return Math.round(Number(normalized) * 100);
};
